<div class="widget-feedback" *ngIf="isFeedbackVisible">
	<div id="feedback-title" class="title" role="text">
		{{ 'dashboard.feedback.title' | translate }}
	</div>
	<div id="feedback-description" class="description" role="text">
		{{ 'dashboard.feedback.description' | translate }}
	</div>
	<vtr-material-button
		linkId="feedback-button"
		[label]="'dashboard.feedback.button' | translate"
		heightSize="md"
		(buttonClick)="openFeedback()"
	></vtr-material-button>
</div>
